import request from '@/router/axios';

export const getList = (current, size, params) => request({
  url: '/api/blade-system/dict-biz/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getParentList = (current, size, params) => request({
  url: '/api/blade-system/dict-biz/parent-list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const getChildList = (current, size, parentId, params) => request({
  url: '/api/blade-system/dict-biz/child-list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    parentId,
  },
  meta: {
    doNotAddProjectId: true,
  },
})

export const remove = ids => request({
  url: '/api/blade-system/dict-biz/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const add = row => request({
  url: '/api/blade-system/dict-biz/submit',
  method: 'post',
  data: row,
})

export const update = row => request({
  url: '/api/blade-system/dict-biz/submit',
  method: 'post',
  data: row,
})

export const getDict = id => request({
  url: '/api/blade-system/dict-biz/detail',
  method: 'get',
  params: {
    id,
  },
})
export const getDictTree = () => request({
  url: '/api/blade-system/dict-biz/tree?code=DICT',
  method: 'get',
})

export const getDictionary = params => request({
  url: '/api/blade-system/dict-biz/dictionary',
  method: 'get',
  params,
})

export const getdictionaryTree = params => request({
  url: '/api/blade-system/dict-biz/dictionary-tree',
  method: 'get',
  params,
})
